import React from "react";
import P from "prop-types";
import styled from "@emotion/styled";

const Modal = ({ children, title, className }) => {
  return (
    <ModalConainer>
      <div className='kt-portlet'>
        <div className='kt-portlet__head'>
          <div className='kt-portlet__head-label'>
            <h3 className='kt-portlet__head-title'>{title}</h3>
          </div>
        </div>
        {children}
      </div>
    </ModalConainer>
  );
};

Modal.propTypes = {
  children: P.node.isRequired,
  title: P.string.isRequired,
};

const ModalConainer = styled.div`
  &:not(:last-child) {
    filter: blur(2px);
    pointer-events: none;
  }
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  opacity: 1;
  width: 50%;
  border: 1px solid #009fff24;

  .kt-portlet {
    box-shadow: 0px 0px 30px 8px #eee;
    margin-bottom: 0px;
    border-radius: 3px;
  }
`;

export default Modal;
